<template>
    <div
        v-show="showBanner"
        class="banner"
    >
       <div ref="scaledBanner" class="scaled-banner">
        <div
            class="banner__loader"
            v-if="loading"
        >
            <v-progress-circular
                indeterminate
                class="banner__loader__spinner"
            ></v-progress-circular>
        </div>
        <v-carousel
            delimiter-icon=""
            height="200"
            :cycle="cycleCarousel"
            prev-icon="bexsicon-left"
            next-icon="bexsicon-right"
            :hide-controls="useDefault || !cycleCarousel"
            :hide-delimiters="useDefault || mobile"
            v-if="showBanner"
        >
            <div class="banner__default" v-if="useDefault && !mobile">
                <div class="banner__default__text">
                    <div v-if="userFirstName.length > 0" class="banner__default__text__welcome">
                        Olá, {{ userFirstName }}!
                    </div>
                    <div class="banner__default__text__headline">
                        <span>{{ bannerDefaultTitle }}</span>
                    </div>
                    <div class="banner__default__text__description">
                        {{ bannerDefaultDescription }}
                    </div>
                </div>
                <v-carousel-item
                    v-for="(img, i) in bannerDefaultImgs"
                    :key="i"
                >
                    <img
                        class="banner__default__img"
                        :src="img"
                    />
                </v-carousel-item>
            </div>
            <v-carousel-item
                v-else
                v-for="(item, i) in items"
                :key="i"
                :style="i === 0 ? 'display: block; !important' : ''"
                :reverse-transition="mobile
                    ? 'fade'
                    :'tab-transition'"
                :transition="mobile
                    ? 'fade'
                    :'tab-transition'"
            >
                <div class="template">
                    <div
                        :class="`template-${item[!mobile ? 'template' : 'templateMobile']}`"
                        :style="backgroundStyle(item)"
                    >
                        <p
                            :style="{
                                color: !mobile ? item.title.color : item.title.colorMobile,
                            }"
                            :class="`template-${item[!mobile ? 'template' : 'templateMobile']}__title`"
                            v-html="!mobile ? item.title.html : item.title.htmlMobile"
                        >
                        </p>
                        <pre
                            :style="{
                                color: !mobile ? item.description.color : item.description.colorMobile,
                            }"
                            :class="`template-${item[!mobile ? 'template' : 'templateMobile']}__description`"
                            v-html="!mobile ? item.description.html : item.description.htmlMobile"
                        >
                        </pre>
                        <div
                            :class="`template-${item[!mobile ? 'template' : 'templateMobile']}__thumb-img`"
                        >
                            <img :src="item.circleImage"/>
                        </div>
                        <template v-if="item.button.visible">
                          <router-link
                              v-if="item.button.link[0] === '/'"
                              :to="item.button.link"
                              @click="bannerActionClicked(item)"
                              :style="{
                                  backgroundColor: !mobile ? item.button.backgroundColor : item.button.backgroundColorMobile,
                                  color: !mobile ? item.button.color : item.button.colorMobile,
                                  fontFamily: item.fontFamily
                              }"
                              target="blank"
                              :class="`template-${item[!mobile ? 'template' : 'templateMobile']}__button`"
                          >
                              {{item.button.text}}
                          </router-link>
                          <a
                              v-else
                              :href="item.button.link"
                              @click="bannerActionClicked(item)"
                              :style="{
                                  backgroundColor: !mobile ? item.button.backgroundColor : item.button.backgroundColorMobile,
                                  color: !mobile ? item.button.color : item.button.colorMobile,
                                  fontFamily: item.fontFamily
                              }"
                              target="blank"
                              :class="`template-${item[!mobile ? 'template' : 'templateMobile']}__button`"
                          >
                              {{item.button.text}}
                          </a>
                        </template>
                    </div>
                </div>
            </v-carousel-item>
        </v-carousel>
       </div>
    </div>
</template>

<script>
export default {
  name: 'banner',
  props: {
    items: Array,
    colorValues: {
      type: Object
      //required if items is inputed
    },
    loading: {
      type: Boolean,
      default: false
    },
    bannerDefaultImgs: {
      type: Array,
      default: []
    },
    bannerDefaultTitle: String,
    bannerDefaultDescription: String
  },
  computed: {
    useDefault() {
      return !this.items || this.items.length === 0;
    },
    showBanner() {
      return !this.useDefault || (this.useDefault && !this.mobile);
    },
    cycleCarousel() {
      return (
        (this.items && this.items.length > 1) ||
        (this.useDefault &&
          this.bannerDefaultImgs &&
          this.bannerDefaultImgs.length > 1)
      );
    }
  },
  mounted() {
    const self = this;
    let scaledBanner = document.getElementsByClassName('scaled-banner')[0];
    if (scaledBanner) {
      scaledBanner.parentElement.style.height =
        window.innerWidth / (this.mobile ? 2.285714285714286 : 6) + 'px';
      scaledBanner.parentElement.style.width = window.innerWidth + 'px';
      scaledBanner.style.transform = `scale(${window.innerWidth /
        (this.mobile ? 480 : 1200)})`;
    }
    window.onresize = event => {
      if (!scaledBanner) {
        scaledBanner = document.getElementsByClassName('scaled-banner')[0];
      }
      scaledBanner.style.transform = `scale(${window.innerWidth /
        (this.mobile ? 480 : 1200)})`;
      scaledBanner.parentElement.style.height =
        window.innerWidth / (this.mobile ? 2.285714285714286 : 6) + 'px';
      scaledBanner.parentElement.style.width = window.innerWidth + 'px';
      self.$forceUpdate();
    };
  },
  methods: {
    backgroundStyle(item) {
      const backgroundImage = !this.mobile
        ? item.backgroundImage
        : item.backgroundImageMobile;
      return {
        background: backgroundImage
          ? `url('${backgroundImage}')`
          : !this.mobile
            ? item.backgroundColor
            : item.backgroundColorMobile,
        backgroundSize: 'cover'
      };
    },
    bannerActionClicked(banner) {
      this.createTrace(this.enums.logTraceActions.bannerActionClicked, {
        name: banner.bannerName,
        link: banner.button.link
      });
    }
  }
};
</script>

<style lang="scss">
@import '../assets/scss/breakpoint';

pre {
  display: block;
  font-family: Calibri, 'Gill Sans', 'Gill Sans MT', 'Trebuchet MS', sans-serif;
  white-space: pre-wrap;
  background-color: transparent;
  padding: initial;
  margin: 0;
  line-height: initial;
  color: initial;
  word-break: initial;
  word-wrap: initial;
  border: initial;
  border-radius: initial;
}

.banner {
  width: 100%;
  overflow: hidden;

  .scaled-banner {
    width: 1200px;
    height: 200px;
    position: relative;
    transform-origin: top left;
    @include breakpoint(mobile) {
      width: 480px;
      height: 210px;
    }
  }
  &__loader {
    background: rgba(0, 0, 0, 0.25);
    width: 100%;
    height: 100%;
    z-index: 9999;
    position: absolute;

    &__spinner {
      color: var(--brand-color);
      width: 50% !important;
      left: 25%;
      top: 50%;
      position: absolute;
      z-index: 99;
    }
  }

  &__default {
    &__text {
      position: absolute;
      left: 12.5%;
      color: var(--banner-font-color);
      top: 13%;
      z-index: 999;

      &__welcome {
        text-transform: capitalize;
      }
      &__headline {
        font-size: 1.5em;
        margin-bottom: 0.5em;
      }
      &__description {
        width: 40%;
      }
    }

    &__img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }

  .v-carousel {
    position: initial;
    height: 200px;
    box-shadow: none;

    @include breakpoint(mobile) {
      height: 210px;
    }

    .v-carousel__next {
      right: 143px !important;
      @include breakpoint(mobile) {
        right: 5px !important;
      }
    }

    .v-carousel__prev {
      left: 130px !important;
      @include breakpoint(mobile) {
        left: 5px !important;
      }
    }

    &:hover {
      .v-carousel__next,
      .v-carousel__prev {
        display: block;
      }
    }
  }

  .v-carousel__item {
    background-color: #f4f4f4;
  }

  .v-carousel__controls {
    background: none;
    height: 10px;
    margin-bottom: 6px;
    .v-btn--icon {
      width: 4px;
      &::before {
        padding: 14px;
      }
    }
  }

  .v-carousel__next,
  .v-carousel__prev {
    @include breakpoint(desktop) {
      display: none;
    }
  }

  .v-carousel__next .v-btn i,
  .v-carousel__prev .v-btn i {
    font-size: 1.5em !important;
  }

  .v-carousel__controls > .v-carousel__controls__item > .v-btn__content > i {
    background-color: #fff;
    padding: 3px;
    border-radius: 20px;
  }
}

$left-space: 26%;
$left-space-button: 25.5%;
$right-space: 4%;
$mobile-left-space: 32%;
$mobile-button-left-space: 30%;

.template {
  overflow: hidden;
  color: #fff;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);

  &-1 {
    text-align: left;
    min-height: 200px;
    transition: inherit;
    padding: 0 0 0 20px;
    @include breakpoint(mobile) {
      height: 210px;
    }
    &__title {
      line-height: 0.9;
      padding-top: 10px;
      position: relative;
      margin-left: $left-space;
      margin-right: $right-space;
      word-break: break-all;
      transition: inherit;
      @include breakpoint(mobile) {
        margin-left: $mobile-left-space;
      }
    }

    &__description {
      position: relative;
      font-weight: 300;
      line-height: 1;
      margin: 0.5em;
      margin-left: $left-space;
      margin-right: $right-space;
      transition: inherit;
      @include breakpoint(mobile) {
        margin-left: $mobile-left-space;
      }
    }

    &__thumb-img {
      overflow: hidden;
      border-radius: 50%;
      margin-left: 12%;
      position: absolute;
      top: 1.8em;
      width: 150px;
      height: 150px;
      transition: inherit;

      @include breakpoint(mobile) {
        margin-left: 3%;
        top: 25%;
        width: 110px;
        height: 110px;
      }

      img {
        margin: 0 auto;
        height: 100%;
        width: auto;
      }
    }

    &__button {
      border-radius: 5px;
      border: none;
      color: #fff;
      position: absolute;
      padding: 0.3em 2em;
      top: 70%;
      font-weight: 500;
      font-size: 1.2em;
      margin-left: $left-space-button;
      transition: inherit;
      text-decoration: none;

      @include breakpoint(mobile) {
        top: 75%;
        padding: 0.25em;
        width: 45%;
        font-size: 1.45em;
        text-align: center;
        margin-left: $mobile-button-left-space;
      }
    }
  }

  &-2 {
    min-height: 200px;
    transition: inherit;
    text-align: center;
    padding: 0 40px;
    @include breakpoint(mobile) {
      height: 210px;
    }

    &__title {
      position: relative;
      padding: 10px 0 0 0;
      line-height: 0.9;
      transition: inherit;
    }

    &__description {
      font-size: 18px;
      position: relative;
      font-weight: 300;
      padding: 0 0 10px 0;
      margin: 0;
      line-height: 0.95;
      transition: inherit;
    }

    &__thumb-img {
      display: none;
    }

    &__button {
      border-radius: 5px;
      border: none;
      color: #fff;
      position: absolute;
      padding: 0.3em 2em;
      top: 64%;
      left: 0;
      right: 0;
      min-width: 15%;
      max-width: 20%;
      margin-left: auto;
      margin-right: auto;
      font-weight: 500;
      font-size: 1.2em;
      transition: inherit;
      text-decoration: none;

      @include breakpoint(mobile) {
        top: 72%;
        min-width: 10%;
        max-width: 45%;
        font-size: 1.45em;
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/Banner.vue